export default "__VITE_ASSET__BWlQM0w$__"